import { NavbarBorrowSystem } from "../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../components/share/HeadTitle";
import { AdminCheckComponent } from "../../components/borrowSystem/AdminCheckComponent";
import { Footer } from "../../components/share/Footer";

export function AdminCheckContainer() {
  const titleName = "รายละเอียดคำขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน";
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <AdminCheckComponent />
      <Footer />
    </div>
  );
}
